import { render, staticRenderFns } from "./BtnJustificativa.vue?vue&type=template&id=55259b46"
import script from "./BtnJustificativa.vue?vue&type=script&lang=js"
export * from "./BtnJustificativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports